﻿import { IPriceDiscountLevel, PriceDiscountLevel } from "./PriceDiscountLevel";

export enum DiscountType
{
    Amount,
    Percent
}

export class PriceDiscount {
    constructor(discount?: IPriceDiscount) {
        // initialize typed object from generic object
        this.discountCode = discount?.discountCode ?? "";
        this.name = discount?.name;
        this.discountType = discount?.discountType ?? DiscountType.Amount;
        this.levels = [];
        if (discount?.levels)
            for (const level of discount.levels)
                this.levels.push(new PriceDiscountLevel(level, this));
    }

    toJSON(): object {
        // return generic object with properties to stringify
        return this;
    }

    discountCode: string;
    name?: string;
    discountType: DiscountType;

    levels: PriceDiscountLevel[];

    findLevel(quantity: number, throwNotFound: boolean = true): PriceDiscountLevel|undefined {
        const level = this.levels.find(level => level.minQuantity <= quantity && (!level.maxQuantity || quantity <= level.maxQuantity));
        if (!level && throwNotFound)
            throw new Error(`"${quantity}" does not exist in discount "${this.discountCode}"`);
        return level;
    }
}

export interface IPriceDiscount {
    discountCode: string;
    name?: string;
    discountType: DiscountType;

    levels: IPriceDiscountLevel[];
}